<template>
  <div>
    <Modal v-if="show" :show="show" :underlay="true" @close="show = false">
      <div class="component">
        <h5 class="component-title">Active filters</h5>
        <div class="filter-list">
          <filter-tag
            class="filter-item"
            :name="filter.name"
            v-for="filter in activeFilters"
            :key="filter.name"
            @remove="onRemove(filter.filter, filter.name)"
          />
        </div>
        <div class="component-button">
          <span @click="clearFiltersClicked" class="clear">Clear filters</span>
          <input
            type="button"
            class="btn btn-secondary"
            value="Close"
            @click="clickedClose"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "FilterListModal",
  data() {
    return {
      show: true
    };
  },
  props: ["type"],
  computed: {
    ...mapGetters("brain/modules", {
      moduleFilters: "filters"
    }),
    ...mapState("brain/drivers", {
      driverFilters: "filters"
    }),
    ...mapState("brain/emergencyDrivers", {
      emergencyDriverFilters: "filters"
    }),

    activeFilters() {
      switch (this.type) {
        case "module":
          return this.getActiveFilters(this.moduleFilters);
        case "emergency-driver":
          return this.getActiveFilters(this.emergencyDriverFilters);
        default:
          return this.getActiveFilters(this.driverFilters);
      }
    }
  },
  methods: {
    getActiveFilters(filters) {
      const activeFilters = [];
      filters.map(filterGroup => {
        filterGroup.filters.map(filter => {
          if (Array.isArray(filter.value)) {
            if (filter.value.length) {
              filter.value.map(value => {
                activeFilters.push({ filter: filter, name: value });
              });
            }
          } else {
            if (filter.value) {
              activeFilters.push({ filter: filter, name: filter.value });
            }
          }
        });
      });
      return activeFilters;
    },

    clickedClose() {
      this.show = false;
    },
    onRemove(filter, value) {
      let values = null;
      if (Array.isArray(filter.value)) {
        values = filter.value.filter(v => v !== value);
      } else {
        value = filter.value;
      }
      if (this.activeFilters.length === 1) {
        this.show = false;
      }
      if (this.type === "module") {
        this.$emit("moduleFilterChange", {
          name: filter.name,
          values: values
        });
      } else if (this.type === "emergency-driver") {
        this.$emit("emergencyDriverFilterChange", {
          name: filter.name,
          values: values
        });
      } else {
        this.$emit("driverFilterChange", {
          name: filter.name,
          values: values
        });
      }
    },
    clearFiltersClicked() {
      this.show = false;
      if (this.type === "module") {
        this.$emit("clearModuleFiltersClicked");
      } else if (this.type === "emergency-driver") {
        this.$emit("clearEmergencyDriverFiltersClicked");
      } else {
        this.$emit("clearDriverFiltersClicked");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.component {
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  .component-title {
    color: $blue;
    font-family: $font-family-sans-serif;
    font-weight: $btn-font-weight;
  }
  .component-paragraph {
    font-size: 16px;
  }
  .form-control {
    margin: 0 0 30px 0;
  }
  .component-button {
    margin-top: auto;
    display: flex;
    input,
    span {
      width: 100%;
      margin: 0 20px 0 0;
      &:last-of-type {
        margin: 0;
      }
    }

    .clear {
      align-self: flex-end;
      color: $blue;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .filter-list {
    margin: 15px 0 30px 0;
    display: flex;
    flex-wrap: wrap;
  }

  .filter-item {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .tag {
    cursor: pointer;
    padding: 5px 10px 5px 10px;
    border-radius: 2px;
    font-size: 12px;
  }
}
</style>
